import listsApi from './listsApi';
import notificationApi from './notificationApi';
import passwordApi from './passwordApi';
import profileApi from './profileApi';
import sessionApi from './sessionApi';
import userApi from './userApi';
import groupApi from './groupApi';

const api = {
  listsApi,
  notificationApi,
  passwordApi,
  profileApi,
  sessionApi,
  userApi,
  groupApi,
};

export default api;
